import React from 'react'
import { MDXTag } from '@mdx-js/tag'


const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{
          "href": "/snippets/main/mdx-redefine/",
          "title": "MDX, redefine markdown tags"
        }}>{`A snippet`}</MDXTag>{` to redefine common markdown tags`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-javascript"
        }}>{`// an Mdx component redefining common tags
export const components = {
    code: Code,
    a: Link
  };

export default function MDX(props){
    const {children} = props;

    return (
    <MDXProvider components={components}>
        {children}
    </MDXProvider>
    )
}
`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "Redefine common markdown tags",
  "keywords": "MDX, React, redefine",
  "menu": "mdx/tags"
};
    